import { IAlertSearchPayload, IParamsAlert, IResponseGetListAlert } from '~/utils/interface/alert';
import axiosClient from './axiosClient';

const url: string = '/api/alerts';

const alertApi = {
  getlist(params: IParamsAlert) {
    return axiosClient.get<IResponseGetListAlert>(`${url}/list`, { params });
  },

  getAlerts(params: IParamsAlert) {
    return axiosClient.get<IResponseGetListAlert>(`${url}/list`, { params });
  },

  postAlert(data: IAlertSearchPayload) {
    return axiosClient.post('/api/notification/find', data);
  },
  getAlertDetail(id: string) {
    return axiosClient.get(`${url}/${id}`);
  },
  resolveAlert(id: string, payload: { note: string }) {
    return axiosClient.put(`${url}/${id}/resolve`, payload);
  },
  getAlertObjects(): Promise<{ data: string[] }> {
    return axiosClient.get('/api/notification/list-alert-object');
  },
};
export default alertApi;
